import "core-js/modules/web.timers";

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import Block from 'wfui-digital-core/es/Block';
import AccessibleClick from 'wfui-digital-core/es/AccessibleClick';
import { requestLogoffConfirmation } from '../../../../../lib/store/session/actions';
import sendBusinessEvent from '../../../../../lib/business-events/business-events';
import LockIcon from '../../../icons/lock/LockIcon';
import StickyFooterContext from '../../../context/StickyFooterContext';
import styles from './SignOff.less';

var SignOff = function SignOff() {
  var dispatch = useDispatch();

  var _useContext = useContext(StickyFooterContext),
      menuConfig = _useContext.menuConfig,
      closeMenu = _useContext.closeMenu,
      secondaryMenu = _useContext.secondaryMenu;

  var signOffConfig = menuConfig.sections[1].sections[0].links[0];

  var signOff = function signOff() {
    closeMenu();
    sendBusinessEvent('signOff_bnb');
    setTimeout(function () {
      return dispatch(requestLogoffConfirmation());
    }, 500);
  };

  return /*#__PURE__*/React.createElement(Block, {
    el: "li",
    layout: true,
    horizontal: true,
    justifyEnd: true,
    className: styles.signoff
  }, /*#__PURE__*/React.createElement(AccessibleClick, null, /*#__PURE__*/React.createElement(Block, {
    el: "a",
    layout: true,
    horizontal: true,
    centered: true,
    role: "button",
    onAccessibleClick: signOff,
    tabIndex: secondaryMenu ? -1 : 0,
    "aria-label": signOffConfig.label
  }, /*#__PURE__*/React.createElement(Block, {
    className: styles.icon
  }, /*#__PURE__*/React.createElement(LockIcon, null)), signOffConfig.label)));
};

export default SignOff;